import {useCallback, useState} from "react";
import {Tenant} from "./types";
import {useTenant} from "./hooks";

export function useMarkItemInGoodCondition() {
    const tenant = useTenant();
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    const submit = useCallback(async (inspectorEmail: string, itemUuid: string, success: () => void) => {
        if (!tenant) {
            setFailed(true);
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(tenant.rentalBaseUrl + '/inspector/item-condition', {
                method: 'post',
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify({
                    itemUuid,
                    inspectorEmail
                })
            });
            if (!response.ok) {
                setFailed(true);
            } else {
                success();
            }
        } catch (error) {
            setFailed(true);
        } finally {
            setLoading(false);
        }
    }, [tenant]);

    return {loading, failed, submit}
}